import { useMemo } from 'react';

import { customerTrialEnded } from 'src/data/customer';
import { useCurrentCustomer } from 'src/store';

export const useIsCustomerTrialEnded = () => {
  const customer = useCurrentCustomer();

  return useMemo(() => customerTrialEnded(customer), [customer]);
};
